import React from 'react'
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import { useState, useMemo, } from "react";
import { useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CustomHeader from '../CustomHeader';

function ClinicUserModal() {

  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const tableStyle = `
          .ag-header-cell-resize::after{
                  background-color: #1991eb52;
              }
      
          .ag-header, .ag-advanced-filter-header{
                  background-color: white;
          }
      
        
      
          .ag-ltr .ag-cell{
                
                  text-align: center;
                  display: flex;
                  // justify-content: center;
                  align-items: center;
          }
      
          .ag-header{
              border: 1px solid #e2e2e2;
              box-shadow: 1px 1px 5px -4px;
              margin-bottom: 1rem;   
              background-color: #4f4f4f !important;
          padding: 0.5rem 0;
          box-sizing: border-box;        
              min-height: 56px !important;
          }
      
          .ag-root-wrapper{
            border: unset;
            background: transparent
          }
      
          .ag-body-viewport{
            border: 1px solid #8080801a;
            border-top-left-radius: 5px !important;
            border-top-right-radius: 5px !important;
            background-color: white;
            box-shadow: 1px 1px 5px -2px;
          }
      
          .ag-theme-quartz .ag-header-cell-filter-button{
          display: none;}
      
      .ag-ltr .ag-header-cell-resize{
          }
      
           .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
              font-size: .9rem;
           }
      
           .ag-body-horizontal-scroll{
              height: 5px !important;
          max-height: 5px !important;
          min-height: 5px !important;
           }
      
           .ag-body-horizontal-scroll-viewport{
              height: 5px !important;
          max-height: 5px !important;
          min-height: 5px !important;
           }
      
          .ag-row{
            border-bottom: 1px solid #8cc8f575;
          }
      
      
      .ag-root ::-webkit-scrollbar-track
      {
          -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
          background-color: #F5F5F5;
      }
      
      .ag-root ::-webkit-scrollbar
      {
          width: 5px;
          background-color: #F5F5F5;
      }
      
      .ag-root ::-webkit-scrollbar-thumb
      {
          background-color: #80808070;
      }
      
      .ag-root ::-webkit-scrollbar-button {
          width: 0px;
          height: 0px;
          visibility: hidden;
      }
      
      .ag-header-cell-sortable .ag-header-cell-label{
         justify-content: center;
      }
      
      .ag-ltr .ag-cell {
            font-weight: 500 !important;
            font-size: 14px;
            letter-spacing: 0.5px;
            color: #05080B !important;
        }
      
        .ag-theme-quartz {
            --ag-odd-row-background-color: rgb(0 145 255 / 4%);
            }
      
            .odd-row {
        background-color: #f8f8fc;
      }
      
      .ag-header-cell-label{
      display: flex;
      justify-content: center;
      }
      
      .ag-paging-panel > .ag-paging-page-size .ag-wrapper {
      border: none;
      background-color: #F4F5F7
      }
      
      .ag-paging-panel{
      display: flex;
      justify-content: space-between;
      }
      
      .ag-paging-row-summary-panel{
      display: none;
      }
      
      .ag-ltr .ag-cell {
          display: flex;
          justify-content: center;
      }
      
              `;

  const [paginationPageSize, setPaginationPageSize] = useState(20);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [
      {
        colId: "No of Team Members",
        minWidth: 900,
      },
    ],
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      headerComponent: CustomHeader,
    };
  }, []);

  const [rowData, setRowData] = useState([
    {
      ModulePermission: "Super Admin",
      Read: "",
      Write: "",
      Delete: "",
    },

    {
      ModulePermission: "Admin",
      Read: "",
      Write: "",
      Delete: "",
    },

    {
      ModulePermission: "Employee",
      Read: "",
      Write: "",
      Delete: "",
    },

    {
      ModulePermission: "Employee",
      Read: "",
      Write: "",
      Delete: "",
    },


  ]);

  const [colDefs, setColDef] = useState([

    {
      headerName: "Module Permission",
      field: "ModulePermission",
      suppressSizeToFit: true,
      cellRenderer: function (params) {
    
        return (
          <>
            <div className="d-flex flex-column">
              <span
                className="fw-semibold m-0"
                style={{}}
              >
                {params.value}
              </span>
            </div>

          </>
        );
      },
    },

    {
      field: "Read",
      headerName: "Read",
      suppressSizeToFit: true,
      cellRenderer: function (params) {
  
        return (
          <>
            <span>
              <input type="checkbox" style={{ height: "13px", width: "13px" }} />
            </span>
          </>
        );
      },
    },

    {
      field: "Write",
      headerName: "Write",
      suppressSizeToFit: true,
      cellRenderer: function (params) {
      
        return (
          <>
            <span>
              <input type="checkbox" style={{ height: "13px", width: "13px" }} />
            </span>
          </>
        );
      },
    },

    {
      field: "Delete",
      headerName: "Delete",
      suppressSizeToFit: true,
      cellRenderer: function (params) {
 
        return (
          <>
            <span>
              <input type="checkbox" style={{ height: "13px", width: "13px" }} />
            </span>
          </>
        );
      },
    },

  ]);

  return (
    <>
      <div>
        <button onClick={handleShow} role='button' className='rounded-1' style={{ fontSize: ".8rem", background: "#314254", padding: ".4rem 1rem", color: "#fff" }}>Add user +</button>

        <Modal show={show} onHide={handleClose} size="xl" dialogClassName="modal-dialog-scrollable">
          <Modal.Header closeButton>
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 mb-4">
                <input type="text" className='form-control ' placeholder='User ID *' style={{ padding: ".33rem 10px" }} />
              </div>

              <div className="col-12 col-md-6 mb-4">
                <input type="text" className='form-control ' placeholder='First Name *' style={{ padding: ".33rem 10px" }} />
              </div>

              <div className="col-12 col-md-6 mb-4">
                <input type="text" className='form-control ' placeholder='Last Name *' style={{ padding: ".33rem 10px" }} />
              </div>

              <div className="col-12 col-md-4 mb-4">
                <input type="text" className='form-control ' placeholder='Email ID *' style={{ padding: ".33rem 10px" }} />
              </div>

              <div className="col-12 col-md-4 mb-4">
                <input type="text" className='form-control' placeholder='Mobile No' style={{ padding: ".33rem 10px" }} />
              </div>

              <div className="col-12 col-md-4 mb-4">
                <Form.Select aria-label="Default select example" className='form-jeuveve' >
                  <option selected disabled value="1">Role</option>
                  <option value="2">Doctor</option>
                  <option value="3">Hospital Administrator</option>
                  <option value="4">IT Administrator</option>
                  <option value="5">Lab Technician</option>
                  <option value="6">Receptionist</option>
                  <option value="7">HR</option>
                </Form.Select>
              </div>

              <div className="col-12 col-md-4 mb-4">
                <input type="text" className='form-control ' placeholder='Username *' style={{ padding: ".33rem 10px" }} />
              </div>

              <div className="col-12 col-md-4 mb-4">
                <input type="text" className='form-control' placeholder='Password *' style={{ padding: ".33rem 10px" }} />
              </div>

              <div className="col-12 col-md-4 mb-4">
                <input type="text" className='form-control' placeholder='Confirm Password *' style={{ padding: ".33rem 10px" }} />
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className='ag-theme-quartz' style={{ height: 500 }}>
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    pagination={false}
                    domLayout="autoHeight"
                    rowClass={"tbl-row-sc"}
                    rowHeight={60}
                    autoSizeStrategy={autoSizeStrategy}
                    paginationPageSize={paginationPageSize}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} className='rounded-1' style={{ fontSize: ".8rem", background: "#314254", padding: ".4rem 1rem", color: "#fff" }}>
              Add User
            </Button>
            <Button onClick={handleClose} className='rounded-1' style={{ fontSize: ".8rem", background: "#979797", padding: ".4rem 1rem", color: "#fff" }}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default ClinicUserModal